import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import vodafone from '../assest/vodafone.png'
import paypal from '../assest/paypal.png'

function Contact () {
    window.scrollTo(0, 0); // العودة إلى الجزء العلوي

    useEffect(() => {
        const inputField = document.querySelectorAll('.myInput');

        inputField.forEach((input) => {
            input.addEventListener('input', function () {
                if (input.value) {
                    // إذا كان هناك نص في الحقل
                    input.style.color = '#fff'; // تعيين اللون إلى الأخضر
                } else {
                    // إذا كان الحقل فارغًا
                    input.style.color = 'initial'; // إعادة تعيين اللون إلى القيمة الافتراضية
                }
            });
        })
    }, [])

    return (
        <section className='contact' id='contact'>
            <div className="container">
                <h2 className="title">
                    <span>Contact Us</span>
                    <p>Contact Us</p>
                </h2>
                <div className="contact-content">
                    {/* <form action={`${process.env.REACT_APP_PROJECTS_API}components/insert_message.php`} method='post' >
                        <div className="input-box">
                            <div className="input-field">
                                <div className="icon"><i class="fa fa-user"></i></div>
                                <input className='myInput' name='name' type="text" placeholder='Your Name' required />
                            </div>
                            <div className="input-field">
                                <div className="icon email"><i class="fa fa-envelope"></i></div>
                                <input className='myInput' name='email' type="email" placeholder='Your Email' required />
                            </div>
                        </div>

                        <div className="input-box">
                            <div className="input-field">
                                <div className="icon"><i class="fa fa-phone"></i></div>
                                <input className='myInput' name='phone' type="phone" placeholder='Your Number' required />
                            </div>
                            <div className="input-field">
                                <div className="icon"><i class="fa fa-inbox"></i></div>
                                <input className='myInput' name="subject" type="text" placeholder='Subject' required />
                            </div>
                        </div>

                        <div className="textarea-field">
                            <div className="icon message"><i class="fa fa-comment"></i></div>
                            <textarea className='myInput' name="message" cols={30} rows={10} placeholder='Message' required></textarea>
                        </div>

                        <div className="btn-box btns">
                            <button type='submit' name='send' class="button type1">
                                <span class="btn-txt"><a>Send</a></span>
                            </button>
                        </div>
                    </form> */}

                    <div className="btn-box btns">
                        <a href='mailto:zamosexp@gmail.com' class="button type1">
                            <span class="btn-txt"><a >Send Message</a></span>
                        </a>
                    </div>

                    <div className="contact-social">
                        <span>
                            <a href='https://www.facebook.com/profile.php?id=61554754706368&mibextid=vk8aRt' target='_blank' class="btn-sosial">
                                <span class="svgContainer">
                                </span>
                                <i class="fa fa-facebook-f"></i>
                                <span class="BG-social"></span>
                            </a>
                        </span>
                        <span>
                            <a href='https://www.instagram.com/zamos.official?igshid=OGQ5ZDc2ODk2ZA==' class="btn-sosial">
                                <span class="svgContainer">
                                </span>
                                <i class="fa fa-instagram"></i>
                                <span class="BG-social"></span>
                            </a>
                        </span>
                        <span>
                            <a href='https://api.whatsapp.com/send/?phone=212672559478' target='_blank' class="btn-sosial">
                                <span class="svgContainer">
                                </span>
                                <i class="fa fa-whatsapp"></i>
                                <span class="BG-social"></span>
                            </a>
                        </span>

                    </div>

                </div>

            </div>
        </section>
    )
}

export default Contact
